module.exports = __webpack_public_path__ + "img/1_2-macerie-2.494fdfa5.png";